"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/** @jsx jsx */
var React = __importStar(require("react"));
var core_1 = require("@emotion/core");
var Radio_1 = __importDefault(require("./Radio"));
var Theme_1 = require("../Theme");
var AnimatedRadio = /** @class */ (function (_super) {
    __extends(AnimatedRadio, _super);
    function AnimatedRadio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimatedRadio.prototype.render = function () {
        var _this = this;
        var smallMargin = function (theme) {
            return core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                margin: ", ";\n                margin-right: ", ";\n                transition: all .2s ease-in-out;\n                transform-origin: top left;\n                &:hover{\n                    transform: scale(1.05);\n                }\n                ", "\n            "], ["\n                margin: ", ";\n                margin-right: ", ";\n                transition: all .2s ease-in-out;\n                transform-origin: top left;\n                &:hover{\n                    transform: scale(1.05);\n                }\n                ", "\n            "])), Theme_1.applyTheme(theme, function (t) { return t.margin.extraSmallMargin; }), Theme_1.applyTheme(theme, function (t) { return t.margin.smallMargin; }), _this.props.radioStyle ? _this.props.radioStyle(theme) : '');
        };
        return (core_1.jsx(Radio_1["default"], __assign({}, this.props, { radioStyle: smallMargin })));
    };
    return AnimatedRadio;
}(React.Component));
exports["default"] = AnimatedRadio;
var templateObject_1;
//# sourceMappingURL=AnimatedRadio.js.map